module.exports = __webpack_public_path__ + "img/2016ninahui.7df4e770.png";